import Vue from 'vue'

// actions
var actions = {
  // 获取分类列表
  getManageList: { method: 'GET', url: '/categories/getManageList' }
}

export default Vue.resource('/categories{/id}', {}, actions)



// WEBPACK FOOTER //
// ./src/api/categories.js